module.exports = __webpack_public_path__ + "static/media/T-shirt_green.09e13420.svg";